import { render, staticRenderFns } from "./ModalFormTemplate.vue?vue&type=template&id=02e77d35&"
import script from "./ModalFormTemplate.vue?vue&type=script&lang=js&"
export * from "./ModalFormTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports